import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/es/industrias/medical-devices/acceso-al-mercado-europeo/")({
  head: () => buildRouteHead("/es/industrias/medical-devices/acceso-al-mercado-europeo"),
  component: SolutionDetail,
});

